import PageTitle from "../../components/PagesComponents/PageTitleSection/PageTitle";

const Videos = () => {
  return (
    <>
    <PageTitle pagetitle="OUR VIDEOS" /> 
    
    <div className=''>
      
      
    </div></>
  )
}

export default Videos